import React, {FC} from 'react'

import cn from 'classnames/bind'

import AuthTemplateWrapper from 'components/blocks/auth/AuthTemplateWrapper'
import ResetPasswordForm from 'components/blocks/auth/ResetPasswordForm'
import {Col, Container, Row} from 'components/elements/grid'

import s from './TemplateResetPassword.module.scss'
const cx = cn.bind(s)

interface ITemplateResetPasswordProps {
	className?: string
}

const TemplateResetPassword: FC<ITemplateResetPasswordProps> = ({className}) => {
	return (
		<AuthTemplateWrapper className={cx('wrapper', className)}>
			<Container>
				<Row>
					<Col md={{offset: 2, span: 8}} lg={{offset: 3, span: 6}} xl={{offset: 4, span: 4}}>
						<ResetPasswordForm />
					</Col>
				</Row>
			</Container>
		</AuthTemplateWrapper>
	)
}

TemplateResetPassword.displayName = 'TemplateResetPassword'

export default TemplateResetPassword
